import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RouterModule, Routes} from '@angular/router';
import {FuseSharedModule} from '@fuse/shared.module';
import {ActivitiesPipesModule} from '@modules/activities/core/pipes/activitiesPipes.module';
import {ActivitiesRoutes} from '@modules/activities/core/player-components/activities.routes';
import {ImageZoningAbstractComponent} from '@modules/activities/core/player-components/image-zoning-base/image-zoning-abstract.component';
import {QcuBaseComponent} from '@modules/activities/core/player-components/qcu-base/qcu-base.component';
import {CommonSharedModule} from '@modules/activities/core/shared-components/common-shared.module';
import {VoiceRecorderReadOnlyComponent} from '@modules/activities/core/shared-components/voice-recorder/voice-recorder-read-only/voice-recorder-read-only.component';
import {DragulaModule} from 'ng2-dragula';
import {SharedMaterialModule} from 'shared/shared-material.module';
import {SharedTranslateModule} from 'shared/shared-translate.module';
import {TtsModule} from '../../../../tts/tts.module';
import {EmbeddedActivitiesComponent} from './embeded-activities/embedded-activities.component';
import {PositionAndColorDotDirective} from './interactive-image/directives/position-and-color-dot.directive';
import {PollComponent} from './poll/poll.component';
import {KeyboardLatexFieldComponent} from './short-answer/keyboard-latex-field/keyboard-latex-field.component';
import {TokenOrLoggedGuard} from "../../../../guards/token-or-logged.guard";


const routes: Routes = [
    {
        path: 'embedded',
        component: EmbeddedActivitiesComponent,
        canActivate: [TokenOrLoggedGuard],
        children: [...ActivitiesRoutes, {
            path: 'multi/:subLessonId',
            loadComponent: () => import('./multi/multi.component').then(m => m.MultiComponent),
            children: ActivitiesRoutes,
        }],
    },
    {
        path: 'multi/:subLessonId',
        loadComponent: () => import('./multi/multi.component').then(m => m.MultiComponent),
        children: ActivitiesRoutes,
    },
    ...ActivitiesRoutes,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FuseSharedModule,
        SharedTranslateModule,
        CommonSharedModule,
        MatButtonModule,
        MatGridListModule,
        MatIconModule,
        MatCardModule,
        ActivitiesPipesModule,
        DragulaModule.forRoot(),
        MatProgressSpinnerModule,
        SharedMaterialModule,
        TtsModule,
    ],
    declarations: [
        VoiceRecorderReadOnlyComponent,
        PositionAndColorDotDirective,
        QcuBaseComponent,
        PollComponent,
        ImageZoningAbstractComponent,
        KeyboardLatexFieldComponent,
        EmbeddedActivitiesComponent,
    ],
    exports: [
        QcuBaseComponent,
        RouterModule,
        VoiceRecorderReadOnlyComponent,
    ],
    providers: [{ provide: MAT_DIALOG_DATA, useValue: {} }]
})
export class PlayersModule {
}